import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    voteId: String,
    questionId: String,
    languageFilters: Array
  }

  declare readonly voteIdValue: string
  declare readonly questionIdValue: string
  declare readonly languageFiltersValue: string[]
  private previousUrl: string | null = null

  toggleAnswerContainer(event: Event): void {
    const target = event.currentTarget as HTMLElement
    const answerId = target.dataset.answerId
    if (!answerId) return

    const answerContainer = document.querySelector(`#answer-${answerId}-container`) as HTMLElement
    const toggleIcon = target.querySelector('.toggle-icon') as HTMLElement
    if (!answerContainer || !toggleIcon) return

    if (answerContainer.classList.contains('hidden')) {
      answerContainer.classList.remove('hidden')
      toggleIcon.innerHTML = '<i class="fas fa-chevron-up"></i>'

      this.previousUrl = window.location.href

      const url = `/votes/translations/${this.voteIdValue}/questions/${this.questionIdValue}/answers/${answerId}/edit?language_filters=${this.languageFiltersValue.join(',')}`
      Turbo.visit(url, {
        frame: `answer-${answerId}-container`,
        action: "replace"
      })

      window.history.pushState({}, '', this.previousUrl)
    } else {
      answerContainer.classList.add('hidden')
      toggleIcon.innerHTML = '<i class="fas fa-chevron-down"></i>'
    }
  }
}
